import { createFileRoute } from "@tanstack/react-router";
import { LabellingWizard } from "@/components/LabellingWizard";

interface SearchParams {
	projectId?: string;
}

export const Route = createFileRoute("/")({
	validateSearch: (search: Record<string, unknown>): SearchParams => ({
		projectId:
			typeof search.projectId === "string" ? search.projectId : undefined,
	}),
	component: LabellingToolPage,
});

function LabellingToolPage() {
	const { projectId } = Route.useSearch();
	return <LabellingWizard projectId={projectId} />;
}
